/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {authenticateWebLoginToken} from '../api'

export const useMutationAuthenticateWebLoginToken = createReactQueryMutationHook('authenticateWebLoginToken', authenticateWebLoginToken)
